/**
 * @deprecated Use TableColumn from '@/models/app-common.model' for El Table column configuration.
 *
 * To migrate:
 * 1. Replace ColumnFilterItem with TableColumn<TRow> for column config.
 * 2. Rename field `value` → `prop` in column config objects (El Table uses `prop`).
 * 3. Track column visibility separately: Array<{ prop: string; isVisible: boolean }>.
 */
export type ColumnFilterItem = {
  label: string;
  value: string;
  isVisible?: boolean;
  width?: number;
  fixed?: string;
  isSortable?: boolean;
  align?: string;
  minWidth?: number;
  isShowOverflowTooltip?: boolean;
};

export enum ColumnFilterEvents {
  UPDATE_COLUMNS = 'updateColumns',
  RESET_COLUMNS = 'resetColumns',
}

export enum ColumnFilterAlignments {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}
